import { Percent } from '@kodiak-finance/sdk-core'

// Single-sided zap thresholds in USD
export const MIN_ZAP_USD_THRESHOLD = 0.5 // $0.5 minimum
export const MAX_ZAP_USD_THRESHOLD = 100000 // $100,000 maximum

// Zap slippage bounds in percentage
export const MIN_ZAP_SLIPPAGE_PERCENTAGE = 0.25 // 0.25% minimum
export const MAX_ZAP_SLIPPAGE_PERCENTAGE = 2 // 2% maximum
export const MAX_ALLOWED_ZAP_PRICE_IMPACT: Percent = new Percent(5, 100) // 5% maximum
